import { AreaResponsable } from "src/app/models/business/AreaResponsability";
import {makeBusinessEntity, PartialBusinessEntityOptions} from "../../../lib/libby/generator";
import { businessOptions } from "../businessOptions";

const DAO_NAME = 'arearesponsableweb';

const defaultOptions: PartialBusinessEntityOptions<any> = {
  hoc: {
    withAccordionSelector: {
      idKey: 'idarearesponsable',
      labelKey: 'descripcion',
    },
    withSelectedChips: {
      idKey: 'idarearesponsable',
      labelKey: 'descripcion',
    },
  },
};

const optionsToUse = !businessOptions.AreaResponsabilityWeb ? defaultOptions : {
  ...defaultOptions,
  ...businessOptions.AreaResponsabilityWeb,
  hoc: { ...defaultOptions.hoc, ...businessOptions.AreaResponsabilityWeb.hoc }
};

const {
  hook: { fetchById, libbyCall, libbyDAO, libbyFetch },
  hoc: { entityAutocomplete, renderPropCall, renderPropFetchById, simpleSelect, accordionSelector, selectedChips },
  context: {
    byIdContext: { useByIdContext, ByIdProvider, ByIdContext },
    generalContext: { useGeneralContext, GeneralProvider, GeneralContext },
  },
} = makeBusinessEntity<AreaResponsable>(DAO_NAME, optionsToUse);

// hooks
export const useAreaResponsabilityWebFetchById = fetchById;
export const useAreaResponsabilityWebLibbyCall = libbyCall;
export const useAreaResponsabilityWebDAO = libbyDAO;
export const useAreaResponsabilityWebLibbyFetch = libbyFetch;

// components/hoc
export const AreaResponsabilityWebAutocomplete = entityAutocomplete;
export const AreaResponsabilityWebCall = renderPropCall;
export const AreaResponsabilityWebById = renderPropFetchById;
export const AreaResponsabilityWebSelect = simpleSelect;
export const AreaResponsabilityWebAccordionSelector = accordionSelector;
export const AreaResponsabilityWebSelectedChips = selectedChips;

// context
// ByIdContext
export const useAreaResponsabilityWebByIdContext = useByIdContext;
export const AreaResponsabilityWebByIdProvider = ByIdProvider;
export const AreaResponsabilityWebByIdContext = ByIdContext;
// GeneralContext
export const useAreaResponsabilityWebContext = useGeneralContext;
export const AreaResponsabilityWebProvider = GeneralProvider;
export const AreaResponsabilityWebContext = GeneralContext;
